import React from 'react';

import DesktopTitle from './components/DesktopTitle';
import MobileTitle from './components/MobileTitle';
import SortInput from './components/SortInput';
import MobileMapSelector from './components/MobileMapSelector';

const Header = () => {
  return(
    <div id='result-banner'>
      <div className='vesta-flex-row-between vesta-padding-x-40 vesta-padding-y-20 vesta-w-full'>
        <div className='vesta-flex-row-center vesta-gap-15'>
          <DesktopTitle />

          <MobileTitle />
        </div>

        <SortInput />

        <MobileMapSelector />
      </div>
    </div>
  )
};

export default Header;
